import { IRectangle, List } from '@fluentui/react';
import { ShortOrderItemModel } from '../../models/OrderModel';
import OrderItemCompactView from './OrderItemCompactView';

type OrderGridProps = {
    items: ShortOrderItemModel[];
    onDetail: (item: ShortOrderItemModel) => void;
    onInvoiceDetail: (id: string) => void;
}

export default function OrderGridView({ items, onDetail, onInvoiceDetail }: OrderGridProps) {
    var columnCount: number = 0;

    const getItemCountForPage = (itemIndex?: number, surfaceRect?: IRectangle): number => {
        if (itemIndex === 0) {
            if (surfaceRect != null && surfaceRect.width < 700) columnCount = 1;
            else if (surfaceRect != null && surfaceRect.width < 1050) columnCount = 2;
            else columnCount = 3;
        }

        return items.length;
    }

    const onRenderCell = (item?: ShortOrderItemModel, index?: number, isScrolling?: boolean) => {
        const width = (100 / columnCount) + '%';
        const hPadding = columnCount === 1 ? " ph-10" : "";
        const vPadding = columnCount === 1 ? " pv-10" : " pv-20";

        if (item == null) return <>empty</>;

        return <div
            key={item.id + "-wrapper"}
            className={"list-grid-tile" + vPadding + hPadding}
            style={{ width: width }}
            data-is-focusable={true}
        >
            <OrderItemCompactView
                key={item.id}
                item={item}
                onDetail={onDetail}
                onInvoiceDetail={onInvoiceDetail}
            />
        </div>;
    }

    return <div className="font-smaller" style={{ marginLeft: -20, marginRight: -20 }}>
        <List
            items={items}
            onRenderCell={onRenderCell}
            getItemCountForPage={getItemCountForPage}
        />
    </div>;
}